import React from 'react';
import { PhoneCarouselContentfulModel } from 'src/api/models/PhoneCarousel';
import PhoneCarouselWrapper from 'src/organisms/carousels/PhoneCarouselWrapper';

export default function getDynamicPhoneCarousel(phoneCarouselProps: PhoneCarouselContentfulModel): React.ReactNode {
  return <PhoneCarouselWrapper phoneItems={phoneCarouselProps.contentfulchildren}/>
}
